import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestQueueService } from '../services/queue/request-queue.service';
import { CustomHttpParams } from '../models/http/custom-http-params.class';

@Injectable()
export class QueueRequestInterceptor implements HttpInterceptor {
	constructor(private readonly requestQueueService: RequestQueueService) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		if (
			request.params instanceof CustomHttpParams &&
			request.params.queueRequest
		) {
			return this.requestQueueService.intercept(request, next);
		}

		return next.handle(request);
	}
}
